import { render, staticRenderFns } from "./AdditionalData.vue?vue&type=template&id=0c4e23ed&scoped=true&"
import script from "./AdditionalData.vue?vue&type=script&lang=js&"
export * from "./AdditionalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e23ed",
  null
  
)

export default component.exports